import {
  FETCH_TALLY_INVENTORY,
  RESET_TALLY_INVENTORY,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const tallyInventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TALLY_INVENTORY:
      return { data: action.payload };
    case RESET_TALLY_INVENTORY:
      return initialState;
    default:
      return state;
  }
};

export default tallyInventoryReducer;
